// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".components-tabel input {\n  text-align: center;\n}\n.components-tabel div.el-input,\n.components-tabel div .el-select {\n  width: 100%;\n}\n.components-tabel .toRed {\n  color: red;\n}\n.table-search input {\n  text-align: left;\n}\n", ""]);
// Exports
module.exports = exports;
